var map = {
	"./0.png": "b180",
	"./1.png": "8ed8",
	"./2.png": "0d74",
	"./3.png": "c00d",
	"./4.png": "d13d",
	"./5.png": "a0a2",
	"./6.png": "0c68",
	"./7.png": "2e99",
	"./8.png": "7c82",
	"./9.png": "4e6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b58f";